<template>
  <section id="app">
    <b-navbar>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            src="./assets/logo.svg"
            alt="Dezzles Derpy Generators"
          />
        </b-navbar-item>
      </template>
      <template slot="start">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">Home</b-navbar-item>
        <b-navbar-item
          v-for="gen in $store.getters.generators"
          :key="gen.key"
          tag="router-link"
          :to="{ name: 'Generator', params: { generator: gen.name } }"
        >
          {{ gen.title }}
        </b-navbar-item>
      </template>

    </b-navbar>
    <div class="container is-fluid">
      <router-view />
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import yaml from 'js-yaml'
import Generators from './store/generators'
import Common from './store/common'

export default {
  data: () => {
    return {
      generators: []
    }
  },
  created: async function () {
    const data = {
      generators: Generators,
      common: Common
    }
    const loadFromYaml = t => {
      console.log(t.split('\n')[0])
      const result = yaml.loadAll(t)[0]
      Object.keys(result).forEach(key => {
        if (typeof result[key] !== 'string') {
          result[key] = result[key].map(v => v || '')
        }
      })
      return result
    }
    const common = {}
    await Promise.all(data.common.map(v => `data/${v}.yaml`).map(axios.get))
      .then(result => result
        .map(v => v.data)
        .map(loadFromYaml)
        .forEach(v => {
          Object.keys(v).forEach(k => { common[k] = v[k] })
        })
      )
    this.$store.commit('common', common)
    for (let idx = 0; idx < data.generators.length; ++idx) {
      const v = data.generators[idx]
      const allData = await Promise.all(v.modules.map(u => `data/${u}`).map(axios.get))
        .then(u =>
          u.map(req => req.data)
            .map(loadFromYaml)
            .reduce((prev, next) => Object.assign(next, prev), {})
        )
      const generatorData = {
        name: v.key,
        data: allData,
        parts: v.parts,
        title: v.title,
        display: v.display,
        generator: v.generator
      }
      this.$store.dispatch('loadGenerator', generatorData)
    }
    this.$store.commit('isFullyLoaded')
  }
}
</script>

<style lang="scss">
</style>
